// @flow
import React, { useEffect } from 'react';
import { useForm, Controller, FormProvider } from 'react-hook-form';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { Select } from '../ui/select/select';
import { NewsBlock } from './parts/NewsBlock';
import { EmbedBlock } from './parts/EmbedBlock';
import { VideoBlock } from './parts/VideoBlock';
import Checkbox from 'material-ui/Checkbox';
import { ArticleListBlock } from './parts/ArticleListBlock';
import { useDidUpdate } from '../../hooks/use-did-update';

const types = [
	{ value: 'news', text: 'Новость' },
	{ value: 'video', text: 'Видео' },
	{ value: 'live', text: 'Прямой эфир' },
	{ value: 'embed', text: 'Embed' },
	{ value: 'listNews', text: 'Список новостей' },
];
const defaultInitial = {
	type: 'news',
	config: {},
};
export const ConfigurableBlockForm = props => {
	const { onSubmit, serverError, children, initialValues = defaultInitial } = props;

	const useFormReturn = useForm({
		defaultValues: {
			...initialValues,
			config: {
				...initialValues.config,
				linked: initialValues.config && initialValues.config.linked ? initialValues.config.linked : [],
			},
		},
	});

	const {
		control,
		register,
		reset,
		watch,
		formState: { errors },
		handleSubmit,
	} = useFormReturn;

	const watchedType = watch('type');

	useDidUpdate(() => {
		reset({
			...initialValues,
			type: watchedType,
			config: {},
		});
	}, [watchedType, initialValues]);

	return (
		<FormProvider {...useFormReturn}>
			<form onSubmit={handleSubmit(onSubmit)}>
				<Controller
					name="slug"
					control={control}
					rules={{ required: true }}
					render={({ fieldState: { error }, field: { onChange, value } }) => (
						<TextField
							value={value}
							errorText={error ? 'Системное имя обязательно для заполнения' : ''}
							onChange={onChange}
							floatingLabelText="Системное имя"
							fullWidth
							floatingLabelFixed={true}
						/>
					)}
				/>
				<Controller
					name="type"
					control={control}
					rules={{ required: true }}
					render={({ field: { onChange, value } }) => (
						<Select floatingLabelText="Тип блока" value={value} onChange={onChange} options={types} />
					)}
				/>
				<Controller
					name="active"
					control={control}
					defaultValue={initialValues.true || true}
					render={({ field: { onChange, value } }) => <Checkbox label="Active" onCheck={onChange} checked={value} />}
				/>
				{watchedType === 'listNews' && <ArticleListBlock register={register} viewer={props.viewer} control={control} />}
				{watchedType === 'news' && <NewsBlock viewer={props.viewer} control={control} />}
				{watchedType === 'embed' && <EmbedBlock control={control} />}
				{watchedType === 'video' && <VideoBlock control={control} />}
				<div style={{ display: 'flex', marginTop: 20 }}>
					<RaisedButton label="Сохранить" type="submit" primary={true} />
					{children}
				</div>
			</form>
		</FormProvider>
	);
};



// WEBPACK FOOTER //
// src/components/configurable-blocks/ConfigurableBlockForm.js